"use strict";

var _interopRequireDefault = require("/www/wwwroot/python/front/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("/www/wwwroot/python/front/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));
var _request = _interopRequireDefault(require("@/utils/request"));
var _default = exports.default = {
  data: function data() {
    var _this = this;
    return {
      listLoading: false,
      adlist: [],
      // 广告列表
      dialogFormVisible: false,
      //控制修改和新增
      title: '添加广告位',
      cate: '',
      //广告类别
      // 新增/修改form
      ruleForm: {
        cate_id: '',
        //广告类别id
        title: '',
        //广告标题
        url: '',
        //跳转链接
        rate: 1,
        //前端展示排序（由大到小排序）
        status: 1,
        //广告状态 1.开启 0.关闭
        content: '',
        // 广告详情
        ad_img: '' // 广告图
      },
      selectedFile: null,
      // 上传的图片
      imageUrl: null,
      // 图片预览
      currentId: null,
      // 当前点击的广告id
      rules: {
        rate: [{
          required: true,
          message: '请输入排序',
          trigger: 'blur'
        }],
        title: [{
          required: true,
          message: '请输入广告标题',
          trigger: 'blur'
        }],
        url: [{
          required: true,
          message: '请输入链接',
          trigger: 'blur'
        }, {
          type: 'url',
          message: '请输入正确的链接',
          trigger: 'blur'
        }],
        ad_img: [
        // { required: true, message: '请上传广告图', trigger: 'blur' },
        // imageUrl存在即可
        {
          validator: function validator(rule, value, callback) {
            if (_this.imageUrl) {
              callback();
            } else {
              callback(new Error('请上传广告图'));
            }
          },
          trigger: 'blur'
        }]
      },
      flag: false,
      // 上传图片的标志
      lastExecutedTime: 0 // 上次执行的时间
    };
  },
  created: function created() {
    // 获取广告类别id
    this.ruleForm.cate_id = this.$route.query.id;
    this.cate = this.$route.query.title;
    // 获取广告列表
    this.getAdList();
  },
  methods: {
    // 获取广告列表
    getAdList: function getAdList() {
      var _this2 = this;
      this.listLoading = true;
      (0, _request.default)({
        url: "/system/ad/ad_list/",
        method: 'get',
        params: {
          cate_id: this.ruleForm.cate_id
        }
      }).then(function (res) {
        if (res.code === 200) {
          _this2.adlist = res.data;
          _this2.listLoading = false;
        }
      });
    },
    getAdInfo: function getAdInfo(id) {
      var _this3 = this;
      this.imageUrl = null, this.currentId = id;
      this.listLoading = true;
      (0, _request.default)({
        url: '/system/ad/ad_get/',
        method: 'get',
        params: {
          ad_id: this.currentId
        }
      }).then(function (res) {
        _this3.ruleForm = res.data;
        _this3.ruleForm.status = _this3.ruleForm.status == true ? 1 : 0;
        _this3.imageUrl = res.data.base64 ? "data:image/png;base64,".concat(res.data.base64) : '';
        // this.ruleForm.ad_img = res.data.base64 ? `data:image/png;base64,${res.data.base64}` : ''
        _this3.listLoading = false;
      }).catch(function (err) {
        console.log(err);
      });
    },
    handleEdit: function () {
      var _handleEdit = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee(row) {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return this.getAdInfo(row.pk);
            case 2:
              this.title = '修改广告位';
              this.dialogFormVisible = true;
            case 4:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function handleEdit(_x) {
        return _handleEdit.apply(this, arguments);
      }
      return handleEdit;
    }(),
    handleAdd: function handleAdd() {
      this.ruleForm = {
        cate_id: this.$route.query.id,
        title: '',
        //广告标题
        url: '',
        //跳转链接
        rate: 1,
        //前端展示排序（由大到小排序）
        status: 1,
        //广告状态 1.开启 0.关闭
        content: '',
        // 广告详情
        ad_img: '' // 广告图
      };
      this.title = '添加广告位', this.dialogFormVisible = true;
    },
    // 选择本地图片
    handleFileChange: function handleFileChange(event) {
      this.flag = true; // 上传图片的标志
      // 获取用户选择的图片
      this.selectedFile = event.target.files[0];
      // 图片格式 只能是 JPG/JPEG/PNG 格式!
      var isJPG = this.selectedFile.type === 'image/jpeg'; // 检查 JPG 格式
      // 图片大小 不能超过 5MB
      var isLt5M = this.selectedFile.size / 1024 / 1024 < 5;
      if (!isJPG) {
        this.$message.error('上传头像图片只能是 JPG/JPEG 格式!');
        return;
      }
      if (!isLt5M) {
        this.$message.error('上传头像图片大小不能超过 5MB!');
        return;
      }
      // 创建一个临时的 URL 对象
      this.imageUrl = URL.createObjectURL(this.selectedFile);
    },
    // 提交创建/修改
    submitForm: function submitForm(formName) {
      var _this4 = this;
      var currentTime = Date.now();
      // 整理参数
      this.listLoading = true;
      this.ruleForm.ad_img = this.selectedFile;
      this.$refs[formName].validate(function (valid) {
        if (valid) {
          if (currentTime - _this4.lastExecutedTime < 2000) {
            _this4.$message.error('请勿频繁操作');
            _this4.lastExecutedTime = currentTime;
            return;
          } else {
            _this4.lastExecutedTime = currentTime;
            if (_this4.title == '添加广告位') {
              (0, _request.default)({
                url: "/system/ad/ad_create/",
                method: 'post',
                data: {
                  title: _this4.ruleForm.title,
                  url: _this4.ruleForm.url,
                  status: _this4.ruleForm.status,
                  content: _this4.ruleForm.content,
                  rate: _this4.ruleForm.rate,
                  cate_id: _this4.ruleForm.cate_id
                }
              }).then(function (res) {
                if (res.code == 200) {
                  // 1.上传图片
                  // 整理格式
                  var formData = new FormData();
                  formData.append('file', _this4.ruleForm.ad_img);
                  formData.append('ad_id', res.data);
                  // 上传图片
                  (0, _request.default)({
                    url: "/system/ad/ad_file_up/",
                    method: 'post',
                    data: formData
                  }).then(function (res) {
                    if (res.code === 200) {
                      console.log('图片上传成功');
                    } else {
                      console.log('图片上传失败');
                    }
                  }).catch(function (err) {
                    console.log(err, '图片上传失败');
                  });
                  _this4.listLoading = false;

                  // 2.提示成功
                  _this4.$message({
                    message: '新增成功',
                    type: 'success'
                  });
                  // 3.关闭form
                  _this4.dialogFormVisible = false;
                  // 4.重新获取数据
                  _this4.getAdList();
                  _this4.lastExecutedTime = currentTime;
                }
              });
            } else {
              (0, _request.default)({
                url: "/system/ad/ad_update/",
                method: 'put',
                data: {
                  ad_id: _this4.currentId,
                  title: _this4.ruleForm.title,
                  url: _this4.ruleForm.url,
                  status: _this4.ruleForm.status,
                  content: _this4.ruleForm.content,
                  rate: _this4.ruleForm.rate
                }
              }).then(function (res) {
                if (res.code == 200) {
                  if (_this4.flag) {
                    // 1.上传图片
                    // 整理格式
                    var formData = new FormData();
                    formData.append('file', _this4.ruleForm.ad_img);
                    formData.append('ad_id', _this4.currentId);
                    // 上传图片
                    (0, _request.default)({
                      url: "/system/ad/ad_file_up/",
                      method: 'post',
                      data: formData
                    }).then(function (res) {
                      if (res.code === 200) {
                        console.log('图片上传成功');
                      } else {
                        console.log('图片上传失败');
                      }
                    }).catch(function (err) {
                      console.log(err, '图片上传失败');
                    });
                    _this4.listLoading = false;
                    // 2.提示成功
                    _this4.$message({
                      message: '修改成功',
                      type: 'success'
                    });
                    // 3.关闭form
                    _this4.dialogFormVisible = false;
                    // 4.重新获取数据
                    _this4.getAdList();
                  } else {
                    console.log('未修改图片');
                    _this4.listLoading = false;
                    // 2.提示成功
                    _this4.$message({
                      message: '修改成功',
                      type: 'success'
                    });
                    // 3.关闭form
                    _this4.dialogFormVisible = false;
                    // 4.重新获取数据
                    _this4.getAdList();
                    _this4.lastExecutedTime = currentTime;
                  }
                }
              });
            }
          }
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    // 取消
    cancel: function cancel() {
      this.dialogFormVisible = false;
      this.imageUrl = null;
      // this.selectedFile = null
    },
    handleBack: function handleBack() {
      this.$router.push('/Ad/AdCate');
    }
  }
};